import { type ParentProps, Show, useContext } from "solid-js"
import { AppProvider } from "@/context/app"
import { SessionContext } from "@/context/hanko"
import { useScrollRestoration } from "@/lib/scrollRestoration"
import { Auth } from "./auth"

export function Main(props: ParentProps) {
  const getSession = useContext(SessionContext)

  useScrollRestoration()

  return (
    <Show when={getSession()} fallback={<Auth />}>
      {session => (
        <Show when={session().userID} fallback={<Auth />}>
          <AppProvider session={session()}>{props.children}</AppProvider>
        </Show>
      )}
    </Show>
  )
}
